import { Component, OnInit, Input, Output, forwardRef, EventEmitter } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormControl, FormGroup, Validators } from '@angular/forms';
import { BaseControl } from '../../../models/base-control';
import { Utilities } from '../../../helpers/utilities'

@Component({
  selector: 'app-re-captcha-r',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ReCaptchaRComponent),
      multi: true
    }
  ],
  templateUrl: './re-captcha-r.component.html',
  styleUrls: ['./re-captcha-r.component.css']
})
export class ReCaptchaRComponent extends BaseControl implements OnInit, ControlValueAccessor {

  ngAfterViewInit() {
  }


}
